export default {"src":"/_next/static/media/lend.aaa954b5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};